import { render } from "./CycleColors.vue?vue&type=template&id=fb269328"
import script from "./CycleColors.vue?vue&type=script&lang=js"
export * from "./CycleColors.vue?vue&type=script&lang=js"
script.render = render

export default script